var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.Entorno.class,style:(_vm.Entorno.style)},[_c('span',[_vm._v(_vm._s(_vm.Entorno.titulo))]),(_vm.Entorno.closable)?_c('v-btn',_vm._b({on:{"click":function($event){return _vm.cerrar_form()}}},'v-btn',_vm.$cfg.btn.cerrar,false),[_c('v-icon',[_vm._v(_vm._s(_vm.$cfg.btn.cerrar.icono))])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }